import { render, staticRenderFns } from "./DebtManager.vue?vue&type=template&id=22bbdda4&scoped=true&"
import script from "./DebtManager.vue?vue&type=script&lang=js&"
export * from "./DebtManager.vue?vue&type=script&lang=js&"
import style0 from "./DebtManager.vue?vue&type=style&index=0&id=22bbdda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbdda4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
